import React, { useState } from 'react';
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem
} from 'reactstrap';

/**
 * Renderiza um botão com três pontos que permite configurar ordenação e layout
 */
export const TripleDot = ({
  setSortOption,
  setLayoutOption,
  layoutOption,
  iconColor = 'inherit'
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggle = () => setIsDropdownOpen((prevState) => !prevState);

  const showSortOptions = layoutOption !== 'one_card_per_queue';

  return (
    <Dropdown direction="left" isOpen={isDropdownOpen} toggle={toggle}>
      <DropdownToggle
        tag="span"
        data-toggle="dropdown"
        aria-expanded={isDropdownOpen}
      >
        <span style={{ padding: '10px', cursor: 'pointer', color: iconColor }}>
          <i className="fas fa-ellipsis-v"></i>
        </span>
      </DropdownToggle>
      <DropdownMenu>
        {showSortOptions && (
          <>
            <DropdownItem header>Ordenação</DropdownItem>
            <DropdownItem onClick={() => setSortOption('queue')}>
              Ordenar por Fila
            </DropdownItem>
            <DropdownItem onClick={() => setSortOption('agent')}>
              Ordenar por Nome do Agente
            </DropdownItem>
            <DropdownItem divider />
          </>
        )}

        <DropdownItem header>Layout</DropdownItem>
        <DropdownItem onClick={() => setLayoutOption('one_card_per_agent')}>
          Mostrar um card por agente
        </DropdownItem>
        <DropdownItem
          onClick={() => setLayoutOption('one_card_per_agent_per_queue')}
        >
          Mostrar um card por agente por fila
        </DropdownItem>
        <DropdownItem onClick={() => setLayoutOption('one_card_per_queue')}>
          Mostrar um card por fila
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};
